import { IPageMetadata } from '../../../interfaces/nextjs';

const PAGE_METADATA: IPageMetadata = {
  _page: 'suggest_water_changes',
  _pageTitle: 'Suggest changes to a water',
};

export { PAGE_METADATA };

// taken from rutilus API model

export const ACCEPTED_FILE_UPLOAD_TYPES = {
  // todo: heic and heic-sequence are not supported by the browser
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  // Todo: https://fishbrain.atlassian.net/browse/FIB-41691
  // 'image/heic': ['.heic'],
  // 'image/heic-sequence': ['.heic-sequence'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};

// Todo: https://fishbrain.atlassian.net/browse/FIB-41691
export const HEIC_ACCEPTED_FILE_UPLOAD_TYPES = {
  // todo: heic and heic-sequence are not supported by the browser
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  // Todo: https://fishbrain.atlassian.net/browse/FIB-41691
  'image/heic': ['.heic'],
  // 'image/heic-sequence': ['.heic-sequence'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};
